export enum WidgetsTypes {
  FETCH_WIDGETS_REQUEST = 'app/analytics/FETCH_WIDGETS_REQUEST',
  FETCH_WIDGETS_SUCCESS = 'app/analytics/FETCH_WIDGETS_SUCCESS',
  FETCH_WIDGETS_FAILURE = 'app/analytics/FETCH_WIDGETS_FAILURE',
}

export interface Widgets {
  id: string;
}
